(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_sale-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__scdInit) return; window.__scdInit = true;
    function pad(n){ return (n < 10 ? '0' : '') + n; }

    // move each info panel to be a direct child of the bar so it drops below the whole bar
    document.querySelectorAll('[data-scd-drop]').forEach(function (d) {
      var bar = d.closest('.announcement-bar');
      if (bar && d.parentElement !== bar) bar.appendChild(d);
    });

    // count down to the next 00:00 UTC (same daily reset Gruns uses; 8 PM ET in summer)
    function tick() {
      var n = new Date();
      var left = 86400 - (n.getUTCHours()*3600 + n.getUTCMinutes()*60 + n.getUTCSeconds());
      if (left >= 86400) left = 86399;
      if (left < 0) left = 0;
      var H = pad(Math.floor(left/3600)), M = pad(Math.floor((left%3600)/60)), S = pad(left%60);
      document.querySelectorAll('[data-scd-h]').forEach(function (e){ e.textContent = H; });
      document.querySelectorAll('[data-scd-m]').forEach(function (e){ e.textContent = M; });
      document.querySelectorAll('[data-scd-s]').forEach(function (e){ e.textContent = S; });
    }
    tick();
    setInterval(tick, 1000);

    // info badge: show tooltip on hover (desktop), tap toggles it (mobile)
    function setDrop(d, show) {
      d.hidden = !show;
      var bar = d.closest('.announcement-bar');
      if (bar) bar.classList.toggle('scd-tip-open', show);
    }
    function dropFor(btn) {
      var bar = btn.closest('.announcement-bar');
      return bar && bar.querySelector('[data-scd-drop]');
    }
    document.querySelectorAll('[data-scd-toggle]').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        var d = dropFor(btn); if (d) setDrop(d, true);
      });
      btn.addEventListener('mouseleave', function () {
        var d = dropFor(btn); if (d && d.dataset.pinned !== '1') setDrop(d, false);
      });
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-scd-toggle]');
      if (btn) {
        var drop = dropFor(btn);
        if (drop) {
          if (drop.dataset.pinned === '1') { drop.dataset.pinned = ''; setDrop(drop, false); }
          else { drop.dataset.pinned = '1'; setDrop(drop, true); }
        }
        return;
      }
      document.querySelectorAll('[data-scd-drop]').forEach(function (d) {
        if (!d.hidden && !d.contains(e.target)) { d.dataset.pinned = ''; setDrop(d, false); }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('[data-scd-drop]').forEach(function (d){ d.dataset.pinned = ''; setDrop(d, false); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
